import React, { useEffect, useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ROLES } from '../constants/roles';
import { useModuleViewAccess } from '../hooks/useModuleViewAccess';
import IssuanceModule from './store/IssuanceModule';
import StoreTransferModule from './store/StoreTransferModule';
import WorkflowGuide from './common/WorkflowGuide';

const ACCESS_ROLES = [
  ROLES.STORE_EXECUTIVE,
  ROLES.STORE_INSPECTOR,
  ROLES.CA_MANAGER,
  ROLES.MRO_MANAGER,
  ROLES.CAMO_QM_MANAGER,
  ROLES.PLANNING_MANAGER,
  ROLES.ACCOUNTABLE_MANAGER,
  ROLES.SUPER_ADMIN
];

const Issuance = () => {
  const location = useLocation();
  const { hasAccess } = useModuleViewAccess('issuance', ACCESS_ROLES);
  const [linkState, setLinkState] = useState({ recordId: null, recordType: null, transferItemId: null });
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const state = location.state;
    setLinkState({
      recordId: state?.recordId || null,
      recordType: state?.recordType || null,
      transferItemId: state?.transferItemId || null
    });
    if (state?.recordType === 'issuance') setActiveTab(0);
    if (state?.recordType === 'transfer') setActiveTab(1);
  }, [location.state]);

  if (!hasAccess) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Access Denied
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          You do not have permission to access Issuance.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Issuance
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Issue parts and materials to maintenance teams, generate delivery challans, and review issuance history.
        Use Store Transfer to move stock (e.g. expired items) between stores with approval.
      </Typography>
      <WorkflowGuide variant="issuance" />
      <Paper sx={{ mb: 3 }}>
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)}>
          <Tab label="Issue & Dispatch" />
          <Tab label="Store Transfer" />
        </Tabs>
      </Paper>
      {activeTab === 0 && (
        <IssuanceModule
          recordId={linkState.recordType === 'issuance' ? linkState.recordId : null}
          recordType="issuance"
        />
      )}
      {activeTab === 1 && (
        <StoreTransferModule
          prefillItemId={linkState.recordType === 'transfer' ? linkState.transferItemId : null}
        />
      )}
    </Box>
  );
};

export default Issuance;
